<template>
  <el-dialog
    class="cbaas-instruction-dialog common-dialog"
    :title="title"
    :visible.sync="showDialog"
    top="25vh"
  >
    <div class="hint">
      <img :src="instructionImg" />
      <div class="info">
        <div v-for="item, index in info" :key="index">{{ item }}</div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" class="sure-btn" @click="makeSure">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import instructionImg from '@/assets/images/instruction/instruction.png'
export default {
  name: 'InstructionDialog',
  props: {
    dialogVisible: Boolean,
    title: {
      type: String,
      default: () => '使用场景说明'
    },
    info: {
      type: Array,
      default: () => ['使用场景说明']
    }
  },
  data() {
    return {
      instructionImg,
      showDialog: false
    }
  },
  watch: {
    dialogVisible: function(val) {
      this.showDialog = val
    },
    showDialog: function(val) {
      this.$emit('update:dialogVisible', val)
    }
  },
  methods: {
    makeSure() {
      this.showDialog = false
    }
  }
}
</script>
<style scoped lang="scss">
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';
.cbaas-instruction-dialog {
  @include adaptation(
    (
      --common-gap-12: 12px,
      --common-gap-16: 16px,
      --common-gap-32: 32px,
      --img-size: 277px
    )
  );
  
  /deep/ .el-dialog {
    width: var(--common-dialog-large-width);
    background: linear-gradient(122deg, #796EFF -1%, #624CFC 101.24%);
    
    .el-dialog__title, .el-dialog__body {
      color: var(--base-color-white);
    }

    .el-dialog__headerbtn {
      &:hover .el-dialog__close {
        opacity: 0.8;
        color: var(--base-color-white);
      }

      .el-dialog__close {
        color: var(--base-color-white);
        transition: opacity 0.2s ease;
      }
    }
  }
  
  .hint {
    padding: var(--common-gap-12) var(--common-gap-16);
    display: flex;
    align-items: center;
    
    img {
      width: var(--img-size);
      height: var(--img-size);
      margin-right: var(--common-gap-32);
    }
    
    .info {
      line-height: 2;
    }
  }

  .sure-btn {
    background: var(--base-color-notice);
    border-color: var(--base-color-notice);

    &:hover, &:focus {
      opacity: 0.8;
    }
  }
}
</style>
